export default __webpack_public_path__ + "static/media/checkmark_unchecked.55ea08b7.png";